export default {
  STORE_REQUEST_TOKEN: 'STORE_REQUEST_TOKEN',
  STORE_ACCESS_TOKEN: 'STORE_ACCESS_TOKEN',
  SET_USER_INFO: 'SET_USER_INFO',
  SET_EVENTS: 'SET_EVENTS',
  SET_UPCOMING_EVENTS: 'SET_UPCOMING_EVENTS',
  CHANGE_EVENT_FILTER: 'CHANGE_EVENT_FILTER',
  CHANGE_EVENT_DETAILS_FILTER: 'CHANGE_EVENT_DETAILS_FILTER',
  SET_CREDENTIALS_INFO: 'SET_CREDENTIALS_INFO',
  SET_EVENT_DETAILS: 'SET_EVENT_DETAILS',
  SUBMIT_REQUEST_FORM: 'SUBMIT_REQUEST_FORM',
  CANCEL_CREDENTIAL: 'CANCEL_CREDENTIAL',
  LOAD_CREDENTIAL: 'LOAD_CREDENTIAL',
  UPDATE_CREDENTIAL: 'UPDATE_CREDENTIAL',
  CLEAR_EVENT_DETAILS: 'CLEAR_EVENT_DETAILS',
  LOGOUT_USER: 'LOGOUT_USER',
};



// WEBPACK FOOTER //
// ./src/actions/types.js